import type { ReactNode } from 'react'

export const SubNavSection = ({
  label,
  children
}: {
  label?: string
  children: ReactNode | ReactNode[]
}) => {
  return (
    <div className="flex flex-row lg:flex-col lg:gap-1">
      {label && (
        <span className="py-2 px-4 font-bold text-xs leading-tight text-primary uppercase transition-all duration-200">
          {label}
        </span>
      )}
      {children}
    </div>
  )
}
